import { v4 as uuidv4 } from 'uuid';

import { BlockProgram } from '@/components/BlockProgram';
import { Program } from '@/types';

const programs = [
  { UUID: uuidv4(), title: 'Podcasts gratuits', route: '' },
  { UUID: uuidv4(), title: 'Nouveautés', route: '' },
  { UUID: uuidv4(), title: 'Nos plus grands succès', route: '' },
  { UUID: uuidv4(), title: 'Les séries de l’été', route: '' },
  { UUID: uuidv4(), title: "Ils font l'actualité", route: '' },
  { UUID: uuidv4(), title: 'Dernières sorties', route: '' },
] as Program[];

export const LibraryLoader = () => {
  return (
    <div className="w-full animate-pulse loader">
      <div className="grid-library">
        {programs.map((program) => (
          <BlockProgram key={program.UUID} program={program} showTitle showKeyword />
        ))}
      </div>
    </div>
  );
};
